__turbopack_context__.v({
  "beachTopRight": "MenuAnnouncement-module__3tTpfG__beachTopRight",
  "content": "MenuAnnouncement-module__3tTpfG__content",
  "referrerImage": "MenuAnnouncement-module__3tTpfG__referrerImage",
  "subText": "MenuAnnouncement-module__3tTpfG__subText",
  "textWrapper": "MenuAnnouncement-module__3tTpfG__textWrapper",
  "winWithFriends": "MenuAnnouncement-module__3tTpfG__winWithFriends",
});
